import React, { ReactElement, useState } from 'react'
import trackEvent from '../../helpers/analytics-utils/track-event'
import { categories, actions } from '../../helpers/analytics-utils/constants'
import FiltersLarge from './filters-large'
import FiltersSmall from './filters-small'

interface WrapperProps {
  children: ReactElement
  count: number
}

const formatCountDisplay = (count: number): string =>
  count > 1 ? `${count} items` : `${count} item`

const Wrapper = ({ children, count }: WrapperProps): JSX.Element => {
  const [expanded, expand] = useState(false)
  const formattedCountDisplay = formatCountDisplay(count)
  const clickHandle = (): void => {
    expand(!expanded)
    trackEvent(
      categories.WHATS_HAPPENING_FILTERS,
      expanded ? actions.COLLAPSE_FILTERS : actions.EXPAND_FILTERS,
      null
    )
  }

  return (
    <>
      <FiltersLarge countDisplay={formattedCountDisplay}>
        {children}
      </FiltersLarge>
      <FiltersSmall countDisplay={formattedCountDisplay} onClick={clickHandle}>
        {children}
      </FiltersSmall>
    </>
  )
}

export default Wrapper
